import Icon from '@ant-design/icons';
import React from 'react';

const OrderCanceledSvg = (props: React.HTMLAttributes<SVGElement>) => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      d="M12 0C5.36761 0 0 5.36703 0 12C0 18.6324 5.36703 24 12 24C18.6324 24 24 18.633 24 12C24.0001 5.36761 18.633 0 12 0ZM16.3917 14.1538C17.0096 14.7718 17.0096 15.7738 16.3917 16.3917C16.0827 16.7007 15.6777 16.8552 15.2728 16.8552C14.8678 16.8552 14.4628 16.7007 14.1538 16.3917L12 14.2379L9.84622 16.3917C9.53723 16.7007 9.13224 16.8552 8.7273 16.8552C8.32236 16.8552 7.91736 16.7007 7.60837 16.3917C6.99044 15.7737 6.99044 14.7718 7.60837 14.1538L9.76215 12L7.60837 9.84622C6.99044 9.22824 6.99044 8.2263 7.60837 7.60832C8.22636 6.99033 9.22829 6.99033 9.84628 7.60832L12.0001 9.76209L14.1538 7.60832C14.7718 6.99033 15.7738 6.99033 16.3917 7.60832C17.0097 8.2263 17.0097 9.22824 16.3917 9.84622L14.2379 12L16.3917 14.1538Z"
      fill="black"
    />
  </svg>
);

export const OrderCanceledIcon = ({ className, ...props }: React.ComponentProps<typeof Icon>) => (
  <Icon component={() => <OrderCanceledSvg className={className} />} {...props} />
);
